import { render, staticRenderFns } from "./NotesByUINComponent.vue?vue&type=template&id=9bd202a4"
import script from "./NotesByUINComponent.vue?vue&type=script&lang=js"
export * from "./NotesByUINComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports